import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var medianPriceBody = {
  name: "bww7am",
  styles: "display:flex;gap:8px;margin-top:4px;"
};
export var medianPriceTitle = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";", designTokenFonts.mini);
export var medianPriceValue = /*#__PURE__*/css("display:flex;flex-direction:row;align-items:center;", designTokenFonts.subheading, " color:", colors.neutral.heavy.default, ";text-transform:lowercase;");
export var medianPriceIcon = /*#__PURE__*/css("width:12px;color:", colors.neutral.heavy.default, ";");
export var medianPriceDelta = /*#__PURE__*/css(designTokenFonts.mini, " background-color:", colors.neutral.subdued.default, ";border:1px solid ", colors.neutral.base.default, ";border-radius:100px;color:", colors.neutral.heavy.default, ";display:flex;align-items:center;justify-content:center;width:64px;height:24px;gap:3px;");
export var medianPriceContainer = isVertical => /*#__PURE__*/css("display:flex;flex-direction:", isVertical ? 'column' : 'row', ";gap:", isVertical ? '16px' : '24px', ";");
var _ref = {
  name: "jbc4oa",
  styles: "transform:rotate(270deg);"
};
var _ref2 = {
  name: "1qx34im",
  styles: "transform:rotate(90deg);"
};
export var medianPriceArrow = isPositive => /*#__PURE__*/css("display:inline-block;", !isPositive && _ref, " ", isPositive && _ref2);
export var roundel = colour => /*#__PURE__*/css("position:relative;top:-1px;width:16px;height:16px;border-radius:8px;border:4px solid ", colour, ";margin-right:8px;");